module.exports = __webpack_public_path__ + "static/media/meta01.601fc519.jpg";